export enum IconEnum {
  // ICONE DE MENU AVEC TITRE
  BASKET_TITLED = 'BASKET_TITLED',
  BUILD_RESERV_TITLED = 'BUILD_RESERV_TITLED',
  CHAT_TITLED = 'CHAT_TITLED',
  CUSTOMER_NOTIFICATION = 'CUSTOMER_NOTIFICATION',
  DOCS_TITLED = 'DOCS_TITLED',
  EMPLOYEE_TITLED = 'EMPLOYEE_TITLED',
  FORM_TITLED = 'FORM_TITLED',
  INCIDENT_TITLED = 'INCIDENT_TITLED',
  INFO_TITLED = 'INFO_TITLED',
  PRODUCTION_PLANNING_TITLED = 'PRODUCTION_PLANNING_TITLED',
  QUOTE_TITLED = 'QUOTE_TITLE',
  SAV_TITLED = 'SAV_TITLED',
  TASK_TITLED = 'TASK_TITLED',
  TRANSPORT_TITLED = 'TRANSPORT_TITLED',
  VT_TITLED = 'VT_TITLED',
  WORKSITE_PLANNING_TITLED = 'WORKSITE_PLANNING_TITLED',
  WORKSITE_TITLED = 'WORKSITE_TITLED',

  // DIVERS
  ADD = 'ADD',
  ARCHIVE = 'ARCHIVE',
  ARROW_BACK_IOS = 'ARROW_BACK_IOS',
  ARROW_BACK = 'ARROW_BACK',
  ARROW_DROP_DOWN = '',
  ARROW_DROP_UP = '',
  ARROW_FORWARD_IOS_ROUNDED = '',
  ATTACH_FILE = 'ATTACH_FILE',
  AUTO_RENEW = 'AUTO_RENEW',
  BUILD = 'BUILD',
  CAST_CONNECTED = 'CAST_CONNECTED',
  CHANGE_USER = 'CHANGE_USER',
  CHECK_CIRCLE_OUTLINE = 'CHECK_CIRCLE_OUTLINE',
  CHECK_CIRCLE = 'CHECK_CIRCLE',
  CHECK = 'CHECK',
  CHECK2 = 'CHECK2',
  CHECKBOX_OUTLINED_BLANK = 'CHECKBOX_OUTLINED_BLANK',
  CHECKBOX = 'CHECKBOX',
  CHEVRON_RIGHT = 'CHEVRON_RIGHT',
  CHEVRON_LEFT = 'CHEVRON_LEFT',
  CLOSE = 'CLOSE',
  CREATE = 'CREATE',
  DELETE_FOREVER = 'DELETE_FOREVER',
  DELETE_OUTLINE_OUTLINED = 'DELETE_OUTLINE_OUTLINED',
  DELETE = 'DELETE',
  DESCRIPTION = 'DESCRIPTION',
  DEVELOPER_BOARD = 'DEVELOPER_BOARD',
  DNS = 'DNS',
  DONE = 'DONE',
  ECO = 'ECO',
  EDIT_OUTLINED = 'EDIT_OUTLINED',
  EDIT = 'EDIT',
  ERROR_OUTLINED = 'ERROR_OUTLINED',
  EURO = 'EURO',
  EVENT_AVAILABLE = 'EVENT_AVAILABLE',
  EXIT_TO_APP = 'EXIT_TO_APP',
  FAST_FORWARD = 'FAST_FORWARD',
  FILE_COPY = 'FILE_COPY',
  FOLDER = 'FOLDER',
  FORMAT_LIST_BULLETED = 'FORMAT_LIST_BULLETED',
  FORUM = 'FORUM',
  FULL_SCREEN = 'FULL_SCREEN',
  GRID_ON = 'GRID_ON',
  GRID = 'GRID',
  HOME = 'HOME',
  HOUSE = 'HOUSE',
  HOUSE2 = 'HOUSE2',
  INFO_OUTLINED = 'INFO_OUTLINED',
  INFO = 'INFO',
  LIBRARY_BOOKS = 'LIBRARY_BOOKS',
  MAIL = 'MAIL',
  MAIL2 = 'MAIL2',
  MAP = 'MAP',
  MENU = 'MENU',
  MOBILE = 'MOBILE',
  MOBILE2 = 'MOBILE2',
  MORE_VERT = 'MORE_VERT',
  NATURE = 'NATURE',
  NOTIFICATION_ACTIVE = 'NOTIFICATION_ACTIVE',
  PANORAMA_FISH_EYE = 'PANORAMA_FISH_EYE',
  PERSON = 'PERSON',
  PHONE_ANDROID = 'PHONE_ANDROID',
  PHONE = 'PHONE',
  PICTURE_AS_PDF = 'PICTURE_AS_PDF',
  PLACE = 'PLACE',
  PLAY_LIST_ADD = 'PLAY_LIST_ADD',
  QUERY_BUILDER = 'QUERY_BUILDER',
  RECEIPT = 'RECEIPT',
  SEARCH = 'SEARCH',
  SEND = 'SEND',
  SHOPPING_CART = 'SHOPPING_CART',
  SUPERVISOR_ACCOUNT = 'SUPERVISOR_ACCOUNT',
  THREE_D_ROTATION = 'THREE_D_ROTATION',
  UN_ARCHIVE = 'UN_ARCHIVE',
  VIEW_COMPACT = 'VIEW_COMPACT',
  VISIBILITY_OFF = 'VISIBILITY_OFF',
  VISIBILITY = 'VISIBILITY',

  // LOGO
  GEKA_LOGO_BASIC = 'GEKA_LOGO_BASIC',
  GEKA_LOGO_GREEN_NO_BG = 'GEKA_LOGO_GREEN_NO_BG',
  GEKA_LOGO_WHITE_BG = 'GEKA_LOGO_WHITE_BG',
  GEKA_LOGO_WHITE_NO_BG = 'GEKA_LOGO_WHITE_NO_BG',
  LOCO_ECOBRIQUE = 'LOCO_ECOBRIQUE',
  LOGO_GREENKUB_WHITE = 'LOGO_GREENKUB_WHITE',
  LOGO_GREENKUB = 'LOGO_GREENKUB',
  LOGO_REDUIT_WHITE = 'LOGO_REDUIT_WHITE',
  LOGO_REDUIT = 'LOGO_REDUIT',
  LOGO_WHITE = 'LOGO_WHITE',
  LOGO = 'LOGO',

  // CUSTOM
  ACCOUNT = 'ACCOUNT',
  ADD_GK = 'ADD_GK',
  ADMINISTRATIF_BLANC = 'ADMINISTRATIF_BLANC',
  AGENDA = 'AGENDA',
  ALERT = 'ALERT',
  ALIGNEMENT_CENTRE = 'ALIGNEMENT_CENTRE',
  ALIGNEMENT_DROITE = 'ALIGNEMENT_DROITE',
  ALIGNEMENT_GAUCHE = 'ALIGNEMENT_GAUCHE',
  ARROW_WHITE_SORT_ASC = 'ARROW_WHITE_SORT_ASC',
  ARROW_WHITE_SORT_DESC = 'ARROW_WHITE_SORT_DESC',
  ARROW_WHITE_SORT_DISABLED = 'ARROW_WHITE_SORT_DISABLED',
  ASSIST = 'ASSIST',
  ATTENTION = 'ATTENTION',
  BOLD = 'BOLD',
  CADENAS = 'CADENAS',
  CALENDER = 'CALENDER',
  CHAMPAGNE = 'CHAMPAGNE',
  CHECK_V1 = 'CHECK_V1',
  CHECK_V2 = 'CHECK_V2',
  CHECK_V3 = 'CHECK_V3',
  CHECKLIST = 'CHECKLIST',
  CHEVRON = 'CHEVRON',
  CLIENT = 'CLIENT',
  COMPTE = 'COMPTE',
  CONFETTI = 'CONFETTI',
  CONTACT = 'CONTACT',
  CONVERSATION_NOTIF = 'CONVERSATION_NOTIF',
  COULEUR_TEXT = 'COULEUR_TEXT',
  CROSS_V1 = 'CROSS_V1',
  CROSS_V2 = 'CROSS_V2',
  CROSS_V3 = 'CROSS_V3',
  CROSS = 'CROSS',
  DASHBOARD = 'DASHBOARD',
  DATE = 'DATE',
  DECONNEXION = 'DECONNEXION',
  DEPOT_MAIRIE = 'DEPOT_MAIRIE',
  DEVIS = 'DEVIS',
  DOC_INTEGRE = 'DOC_INTEGRE',
  DOC_PAS_INTEGRE = 'DOC_PAS_INTEGRE',
  DOC = 'DOC',
  EMPLOYEE_EN_CHARGE = 'EMPLOYEE_EN_CHARGE',
  ENVOYER = 'ENVOYER',
  ESPACE_DOCUMENTAIRE = 'ESPACE_DOCUMENTAIRE',
  FICHIER_JPG = 'FICHIER_JPG',
  FICHIER_PDF = 'FICHIER_PDF',
  FICHIER = 'FICHIER',
  FIXE = 'FIXE',
  FLEUR = 'FLEUR',
  FRANCE = 'FRANCE',
  FUSEE = 'FUSEE',
  GEOPORTAIL_V1 = 'GEOPORTAIL_V1',
  GEOPORTAIL_V2 = 'GEOPORTAIL_V2',
  GEOPORTAIL_V3 = 'GEOPORTAIL_V3',
  INFO_ODOO_CRM = 'INFO_ODOO_CRM',
  INFORMATION = 'INFORMATION',
  INSTALLATION_BLANC = 'INSTALLATION_BLANC',
  ITALIQUE = 'ITALIQUE',
  KOZIKAZA_V1 = 'KOZIKAZA_V1',
  KOZIKAZA_V2 = 'KOZIKAZA_V2',
  LIVRAISON_BLANC = 'LIVRAISON_BLANC',
  LIVRAISON = 'LIVRAISON',
  LOADER_GREEN = 'LOADER_GREEN',
  LOADER = 'LOADER',
  LOCALISATION = 'LOCALISATION',
  LOUPE = 'LOUPE',
  OFFRE = 'OFFRE',
  PANIER = 'PANIER',
  PARAMETRE = 'PARAMETRE',
  PLANNING = 'PLANNING',
  PROJECT = 'PROJECT',
  RAPPORT_TECHNIQUE = 'RAPPORT_TECHNIQUE',
  REALISATION = 'REALISATION',
  RESYNCHRONISATION = 'RESYNCHRONISATION',
  RETOUR = 'RETOUR',
  SANS_PC_BLANC = 'SANS_PC_BLANC',
  SIGNATURE_GREEN = 'SIGNATURE_GREEN',
  SIGNATURE = 'SIGNATURE',
  SOULIGNE = 'SOULIGNE',
  STATISTIQUE = 'STATISTIQUE',
  SUIVIE_INSTRUCTION = 'SUIVIE_INSTRUCTION',
  SURFACE_PARCELLE_V1 = 'SURFACE_PARCELLE_V1',
  SURFACE_PARCELLE_V2 = 'SURFACE_PARCELLE_V2',
  SURFACE_PARCELLE_V3 = 'SURFACE_PARCELLE_V3',
  TACHE = 'TACHE',
  TELECHARGEMENT = 'TELECHARGEMENT',
  TELEPHONE = 'TELEPHONE',
  TRIE_ALPHABETIQUE_V1 = 'TRIE_ALPHABETIQUE_V1',
  TRIE_ALPHABETIQUE_V2 = 'TRIE_ALPHABETIQUE_V2',
  TRIE_ALPHABETIQUE_V3 = 'TRIE_ALPHABETIQUE_V3',
  USAGE = 'USAGE',
  USER_CHECK_INTERFACE_SYMBOL = 'USER_CHECK_INTERFACE_SYMBOL',
  WORKSITE = 'WORKSITE',
  GUIDE = 'GUIDE',
  FAB_FR = 'FAB_FR',
  THUMB_UP = 'THUMB_UP'
}
